import axios from 'axios';
import {AUTHORIZATION_PROPERTY} from "../../../constants";
import * as Sentry from '@sentry/browser';

const httpClient = axios.create(
    {
      baseURL: "/api",
      headers: {
        "LDAP-ADMIN-USER-ID": JSON.parse(localStorage.getItem(AUTHORIZATION_PROPERTY)).accountId
      }
    }
);

httpClient.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (!error.response) {
        console.log(error.request);
        console.log(error);
        alert("네트워크 연결에 실패하였습니다. 잠시 후 다시 시도해주세요.")
      } else if (error.response.data.code === "api.response.auth.notLogin") {
        alert("로그인 토큰이 만료되었습니다. 다시 로그인해주세요.");
        window.document.location = "/login";
      } else {
        Sentry.captureException(error);
      }
      return Promise.reject(error);
    }
);

export default httpClient;
